import React, { useEffect, useRef, useState } from 'react';
import styles from './progress.css';
import { useSelector } from 'react-redux';

/**
 *
 * @param question
 * @returns {JSX.Element}
 * @constructor
 */
const Progress = ( { question } ) => {
    const { hatchGameProgress, calendar: { settings } } = useSelector( ( state ) => state );
    const progressDirection = 'min';
    let progress = useRef();
    const [ getProgressVal, setProgressVal ] = useState( { progressVal: '100%' } );

    const getProgressValue = () => {
        switch ( progressDirection ) {
            case 'max': return ( 100 / hatchGameProgress.timerLimits ) * hatchGameProgress.timerProgress;
            case 'min': return  100 - ( ( 100 / hatchGameProgress.timerLimits ) * hatchGameProgress.timerProgress );
            default: return ( 100 / hatchGameProgress.timerLimits ) * hatchGameProgress.timerProgress;
        }
    };

    useEffect( () => {
        let val = getProgressValue();
        if ( val > 100 ) {
            val = 100;
        }
        if ( val < 1 ) {
            val = 0;
        }
        setProgressVal( { progressVal: val + '%' } );
    }, [ hatchGameProgress ] );

    useEffect( () => {
        setProgressVal( '100%' );
    }, [ question ] );

    return (
        <div className={ styles.wrapper }>
            <div
                style={ {
                    transition: ( getProgressVal.progressVal === '100%' ) ? '0s linear' : '1s linear',
                    width: getProgressVal.progressVal,
                    backgroundColor: settings.appearance.highlight_color ? settings.appearance.highlight_color : '#90ee90'
                } }
                ref={ progress }
                className={ styles.progress }/>
        </div>
    );
};

export default Progress;